import { AnimationBaseController, AnimationTextStyle, IAnimationControllerConfiguration, Inject, SimpleBaseController } from "@denishussar/html5-game-engine";
import { filters } from "pixi.js";
import { AnimationContents } from "../../../AnimationContents";
import { ButtonController } from "../../Common/ButtonController";
import { LevelEvents, UIEvents } from "../../Constants/Events";
import { COIN56, COIN64, COIN70 } from "../../Constants/ImageConstants";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { GarageLogic } from "../../Logic/GarageLogic";
import { AppStateEnum, GameModel } from "../../Models/GameModel";
import { thousandSpacing } from "../../Utils/StringRework";

export interface IRepairModalOptions {
    parent: SimpleBaseController,
}

export class RepairModalController extends AnimationBaseController {
    $model: GameModel;
    private blur;
    constructor(
        @Inject private options: IRepairModalOptions,
        @Inject private logic: GameLogic,
        @Inject private garageLogic: GarageLogic,
    ) {
        super("RepairModalController");
    }

    getConfiguration(): IAnimationControllerConfiguration {
        const events = {};
        events[LevelEvents.showRepair] = (show) => {
            if (show) this.showModal();
            else this.hideModal();
        }
        return {
            animationContent: AnimationContents.END_SCREEN_JSON,
            libraryName: "modal_restart",
            modelWatch: {
                appState: (state) => {
                }
            },
            modelEvents: events,
            childControllers: {
                btnOk: {
                    instanceName: "btn_buy_restart",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            if (!this.garageLogic.repairCar()) return;
                            this.hideModal();
                            this.logic.resetLevel();
                            this.logic.setState(AppStateEnum.game);
                        }
                    }
                },
                btnBack: {
                    instanceName: "btn_back_restart",
                    controller: ButtonController,
                    options: {
                        onClick: () => {
                            this.hideModal();
                        }
                    }
                },
            }
        }
    }
    onInitialize() {
        this.blur = new filters.BlurFilter(2, 0.5, 0.25);
        this.hideModal();
        this.setStyles();
    }

    onResize(width: number, height: number, scale: number) {
        if (width / height > 1.0)
            this.scaleX = this.scaleY = height / scale / 1080;
        else
            this.scaleX = this.scaleY = Math.min(width / scale / 1080, height / scale / 1920);


    }

    hideModal() {

        this.display.renderable = false;
        this.display.interactiveChildren = false;

        const screen = this.options.parent.$childControllers.get('screen') as SimpleBaseController;
        if (screen.display) {
            screen.display.filters = [];
            screen.display.interactiveChildren = true;
        }
        this.$model.pause = false;
    }

    showModal() {
        this.display.renderable = true;
        this.display.interactiveChildren = true;
        const screen = this.options.parent.$childControllers.get('screen') as SimpleBaseController;
        screen.display.filters = [this.blur];
        screen.display.interactiveChildren = false;
        this.$model.pause = true;

        if (this.logic.calcRepairPrice() > this.$model.coins) {
            (this.$childControllers.get("btnOk") as ButtonController).disabled();
            (this.$childControllers.get("btnOk") as ButtonController).gotoAndStop("disabled");
        }
        else {
            (this.$childControllers.get("btnOk") as ButtonController).enabled();
            (this.$childControllers.get("btnOk") as ButtonController).gotoAndStop("active");
        }

        this.setPrice(this.logic.calcRepairPrice());
        this.setTextVerticalAlignByQuery("btn_buy_restart.price_txt", "middle");

        this.localise();
    }

    private setPrice(n: number){
        this.setTextByQuery("btn_buy_restart.price_txt_active", "<coin> </coin>   " + thousandSpacing(n));
        this.setTextByQuery("btn_buy_restart.price_txt_hover", "<coin> </coin>   " + thousandSpacing(n));
        this.setTextByQuery("btn_buy_restart.price_txt_press", "<coin> </coin>  " + thousandSpacing(n));
        this.setTextByQuery("btn_buy_restart.price_txt_disabled", "<coin> </coin>   " + thousandSpacing(n));
    }

    private localise(){
        this.setTextByQuery("text_endscreen_repair", LocalizationContents.getText("text_endscreen_repair"));
        this.setTextByQuery("title_endscreen_repair", LocalizationContents.getText("title_endscreen_repair"));
        this.setTextByQuery("btn_buy_restart.not_enough_money_txt", LocalizationContents.getText("button_endscreen_repair"));
        this.setTextVerticalAlignByQuery("text_endscreen_repair", "middle");
        this.setTextVerticalAlignByQuery("title_endscreen_repair", "middle");
    }

    private setStyles(){
        const coin64: AnimationTextStyle = {
            imgSrc: COIN64,
            height: 56,
            width: 58,
            valign: "middle",
            padding: 10,
            fontSize: 64,
        }
        const coin70: AnimationTextStyle = {
            imgSrc: COIN70,
            height: 60,
            width: 70,
            valign: "middle",
            padding: 10,
            fontSize: 70,
        }
        const coin56:AnimationTextStyle = {
            imgSrc: COIN56,
            height: 54,
            width: 56,
            valign: "middle",
            padding: 10,
            fontSize: 70,
        }
        this.setTextStyleByQuery("btn_buy_restart.price_txt_active", {valign: "middle"}, {
            coin: coin64,
        })
        this.setTextStyleByQuery("btn_buy_restart.price_txt_hover", {valign: "middle"}, {
            coin: coin70,
        })
        this.setTextStyleByQuery("btn_buy_restart.price_txt_press", {valign: "middle"}, {
            coin: coin56,
        })
        this.setTextStyleByQuery("btn_buy_restart.price_txt_disabled", {valign: "middle"}, {
            coin: coin64,
        })
    }
}